import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";

import ClienteCollaudi from "./ClienteCollaudi";

// BETALUMINA_COLLAUDI_FRONT_FIX26B_20261024
const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://interventi.synology.me:5050";

const formattaData = (value) => {
  if (!value || value === "-") return "—";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return String(value);

  return new Intl.DateTimeFormat("it-IT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(date);
};

const valore = (value) => {
  if (
    value === undefined ||
    value === null ||
    value === "" ||
    value === "-"
  ) {
    return "—";
  }

  return String(value);
};

const parseClienteFileList = (value) => {
  if (!value || value === "-" || value === "null") return [];
  if (Array.isArray(value)) return value.filter(Boolean);

  const text = String(value).trim();
  if (!text) return [];

  try {
    const parsed = JSON.parse(text);
    if (Array.isArray(parsed)) return parsed.filter(Boolean);
    if (typeof parsed === "string" && parsed.trim()) return [parsed.trim()];
  } catch (_) {
    // Compatibilità con vecchio formato singolo /uploads/file.ext
  }

  return [text];
};

const buildFileUrl = (path) => {
  if (!path) return "#";
  return String(path).startsWith("http")
    ? path
    : `${API_BASE_URL}${path}`;
};

const getFileName = (path) => {
  if (!path) return "Documento";
  const clean = String(path).split("?")[0].split("#")[0];
  return clean.split("/").filter(Boolean).pop() || "Documento";
};

const Dato = ({ label, children, wide = false }) => (
  <div
    style={{
      padding: "12px 13px",
      borderRadius: "10px",
      background: "#f7f9fb",
      minWidth: 0,
      border: "1px solid #e6ebf0",
      gridColumn: wide ? "1 / -1" : undefined,
    }}
  >
    <div
      style={{
        fontSize: "10px",
        color: "#778190",
        textTransform: "uppercase",
        letterSpacing: "0.055em",
        fontWeight: 800,
      }}
    >
      {label}
    </div>
    <div
      style={{
        marginTop: "5px",
        fontSize: "14px",
        fontWeight: 650,
        color: "#25364a",
        overflowWrap: "anywhere",
      }}
    >
      {children}
    </div>
  </div>
);

const StatCard = ({ label, value: cardValue, description }) => (
  <div
    style={{
      padding: "14px 15px",
      border: "1px solid #dfe5eb",
      borderRadius: "12px",
      background: "#fff",
      minWidth: 0,
    }}
  >
    <div
      style={{
        fontSize: "24px",
        lineHeight: 1,
        fontWeight: 850,
        color: "#243750",
      }}
    >
      {cardValue ?? 0}
    </div>
    <div
      style={{
        marginTop: "7px",
        fontSize: "13px",
        color: "#26374b",
        fontWeight: 800,
      }}
    >
      {label}
    </div>
    {description && (
      <div
        style={{
          marginTop: "3px",
          fontSize: "11px",
          color: "#7a8490",
        }}
      >
        {description}
      </div>
    )}
  </div>
);

const StatoBadge = ({ stato }) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      padding: "4px 9px",
      borderRadius: "999px",
      border: "1px solid #d6dce2",
      background: "#f2f4f7",
      fontSize: "12px",
      fontWeight: 700,
      whiteSpace: "nowrap",
    }}
  >
    {stato || "Senza stato"}
  </span>
);

const TabButton = ({ active, onClick, children }) => (
  <button
    type="button"
    onClick={onClick}
    style={{
      border: 0,
      borderBottom: active ? "3px solid #244f79" : "3px solid transparent",
      background: "transparent",
      color: active ? "#183654" : "#697386",
      padding: "11px 14px",
      fontWeight: active ? 850 : 700,
      cursor: "pointer",
      whiteSpace: "nowrap",
    }}
  >
    {children}
  </button>
);

const Section = ({ title, children }) => (
  <section
    style={{
      padding: "17px",
      borderRadius: "13px",
      background: "#fff",
      border: "1px solid #dfe5eb",
    }}
  >
    <h3
      style={{
        margin: "0 0 13px",
        fontSize: "16px",
        color: "#243750",
      }}
    >
      {title}
    </h3>
    {children}
  </section>
);

const DocumentoCard = ({ categoria, path }) => {
  const href = buildFileUrl(path);
  const name = getFileName(path);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "minmax(0, 1fr) auto",
        gap: "12px",
        alignItems: "center",
        padding: "12px 13px",
        borderRadius: "10px",
        border: "1px solid #e2e7ec",
        background: "#fafbfc",
      }}
    >
      <div style={{ minWidth: 0 }}>
        <div
          style={{
            fontSize: "11px",
            color: "#708090",
            fontWeight: 800,
            textTransform: "uppercase",
            letterSpacing: "0.045em",
          }}
        >
          {categoria}
        </div>
        <div
          title={name}
          style={{
            marginTop: "4px",
            fontSize: "14px",
            fontWeight: 700,
            color: "#243750",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {name}
        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: "7px",
          flexWrap: "wrap",
          justifyContent: "flex-end",
        }}
      >
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "none",
            padding: "7px 10px",
            borderRadius: "8px",
            border: "1px solid #b9c8d8",
            background: "#fff",
            color: "#244f79",
            fontSize: "12px",
            fontWeight: 800,
          }}
        >
          Apri
        </a>
        <a
          href={href}
          download={name}
          style={{
            textDecoration: "none",
            padding: "7px 10px",
            borderRadius: "8px",
            border: "1px solid #244f79",
            background: "#244f79",
            color: "#fff",
            fontSize: "12px",
            fontWeight: 800,
          }}
        >
          Scarica
        </a>
      </div>
    </div>
  );
};

const ClienteSchedaOperativa = ({ clienteId, onClose }) => {
  const [dati, setDati] = useState(null);
  const [caricamento, setCaricamento] = useState(true);
  const [errore, setErrore] = useState("");
  const [tab, setTab] = useState("panoramica");
  const [documentCategory, setDocumentCategory] = useState("manualistica");
  const [documentFiles, setDocumentFiles] = useState([]);
  const [documentUploadBusy, setDocumentUploadBusy] = useState(false);
  const [documentUploadMessage, setDocumentUploadMessage] = useState("");
  const [documentDeleteBusy, setDocumentDeleteBusy] = useState("");
  const [reloadNonce, setReloadNonce] = useState(0);

  useEffect(() => {
    const precedenteOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = precedenteOverflow;
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  useEffect(() => {
    let attivo = true;

    const caricaScheda = async () => {
      setCaricamento(true);
      setErrore("");

      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(
          `${API_BASE_URL}/clienti/${clienteId}/storico`,
          {
            headers: token
              ? { Authorization: `Bearer ${token}` }
              : {},
            withCredentials: true,
          }
        );

        if (attivo) setDati(response.data);
      } catch (error) {
        console.error("Errore caricamento scheda cliente:", error);

        if (attivo) {
          setErrore(
            error?.response?.data?.message ||
              "Impossibile caricare la scheda cliente"
          );
        }
      } finally {
        if (attivo) setCaricamento(false);
      }
    };

    if (clienteId) caricaScheda();

    return () => {
      attivo = false;
    };
  }, [clienteId, reloadNonce]);

  const cliente = dati?.cliente || {};
  const statistiche = dati?.statistiche || {};
  const interventi = Array.isArray(dati?.interventi)
    ? dati.interventi
    : [];

  const ultimoIntervento = useMemo(() => {
    if (!interventi.length) return null;

    const validi = interventi
      .map((item) => ({
        item,
        ts: new Date(item.data || 0).getTime(),
      }))
      .filter((x) => !Number.isNaN(x.ts))
      .sort((a, b) => b.ts - a.ts);

    return validi[0]?.item || interventi[0] || null;
  }, [interventi]);

  const documenti = useMemo(() => {
    const categorie = [
      ["Foto impianto", cliente.foto_impianto],
      ["Documenti firmati", cliente.documenti_firmati],
      ["Verbale collaudo", cliente.verbale_collaudo],
      ["Manualistica", cliente.manualistica],
      ["Certificazioni", cliente.certificazioni],
    ];

    return categorie.flatMap(([categoria, value]) =>
      parseClienteFileList(value).map((path, index) => ({
        id: `${categoria}-${index}-${path}`,
        categoria,
        path,
      }))
    );
  }, [
    cliente.foto_impianto,
    cliente.documenti_firmati,
    cliente.verbale_collaudo,
    cliente.manualistica,
    cliente.certificazioni,
  ]);


  const uploadDocumenti = async () => {
    if (!clienteId || documentFiles.length === 0 || documentUploadBusy) return;

    setDocumentUploadBusy(true);
    setDocumentUploadMessage("");

    try {
      const token = localStorage.getItem("token");
      const formData = new FormData();

      documentFiles.forEach((file) => {
        formData.append(documentCategory, file);
      });

      const response = await axios.post(
        `${API_BASE_URL}/clienti/${clienteId}/documenti`,
        formData,
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
          withCredentials: true,
        }
      );

      const added = Number(response?.data?.aggiunti || documentFiles.length);
      setDocumentUploadMessage(
        `${added} ${added === 1 ? "documento caricato" : "documenti caricati"} correttamente.`
      );
      setDocumentFiles([]);
      setReloadNonce((value) => value + 1);
    } catch (error) {
      console.error("Errore upload documenti cliente:", error);
      setDocumentUploadMessage(
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Errore durante il caricamento dei documenti."
      );
    } finally {
      setDocumentUploadBusy(false);
    }
  };


  const deleteDocumento = async (documento) => {
    const fieldByLabel = {
      "Foto impianto": "foto_impianto",
      "Documenti firmati": "documenti_firmati",
      "Verbale collaudo": "verbale_collaudo",
      Manualistica: "manualistica",
      Certificazioni: "certificazioni",
    };

    const categoria = fieldByLabel[documento?.categoria];
    const filePath = documento?.path;
    if (!clienteId || !categoria || !filePath) return;

    const nomeFile = String(filePath).split("/").pop() || "questo documento";
    const conferma = window.confirm(
      `Rimuovere "${nomeFile}" dal cliente e dal Portale Cliente?\n\nIl file fisico resterà conservato sul NAS per eventuale recupero.`
    );
    if (!conferma) return;

    const busyKey = `${categoria}:${filePath}`;
    setDocumentDeleteBusy(busyKey);
    setDocumentUploadMessage("");

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${API_BASE_URL}/clienti/${clienteId}/documenti`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            categoria,
            path: filePath,
          }),
        }
      );

      const payload = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(payload.message || "Errore eliminazione documento");
      }

      setDocumentUploadMessage("Documento rimosso correttamente.");
      setReloadNonce((value) => value + 1);
    } catch (error) {
      console.error("Errore eliminazione documento:", error);
      setDocumentUploadMessage(
        error?.message || "Errore durante l'eliminazione del documento."
      );
    } finally {
      setDocumentDeleteBusy("");
    }
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Scheda cliente"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 50000,
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        padding: "14px 12px",
        background: "rgba(16, 24, 32, 0.68)",
        overflowY: "auto",
      }}
    >
      <div
        style={{
          width: "min(1180px, calc(100vw - 24px))",
          minHeight: "320px",
          borderRadius: "18px",
          background: "#f4f6f8",
          boxShadow: "0 24px 70px rgba(0,0,0,0.32)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "16px",
            alignItems: "flex-start",
            padding: "18px 22px",
            background: "linear-gradient(135deg, #20324d, #3d5b84)",
            color: "#fff",
          }}
        >
          <div style={{ minWidth: 0 }}>
            <div
              style={{
                fontSize: "11px",
                opacity: 0.82,
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                fontWeight: 800,
                color: "#fff",
              }}
            >
              Scheda cliente
            </div>

            <h2
              style={{
                margin: "6px 0 0",
                fontSize: "26px",
                lineHeight: 1.1,
                color: "#fff",
                fontWeight: 850,
                overflowWrap: "anywhere",
              }}
            >
              {cliente.nome || "Caricamento cliente…"}
            </h2>

            {(cliente.referente || cliente.email || cliente.telefono) && (
              <div
                style={{
                  marginTop: "7px",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px 14px",
                  fontSize: "12px",
                  color: "rgba(255,255,255,0.88)",
                }}
              >
                {cliente.referente && <span>Referente: {cliente.referente}</span>}
                {cliente.telefono && <span>{cliente.telefono}</span>}
                {cliente.email && <span>{cliente.email}</span>}
              </div>
            )}
          </div>

          <button
            type="button"
            onClick={onClose}
            aria-label="Chiudi scheda cliente"
            style={{
              width: "38px",
              height: "38px",
              flex: "0 0 auto",
              border: "1px solid rgba(255,255,255,0.45)",
              borderRadius: "50%",
              background: "rgba(255,255,255,0.11)",
              color: "#fff",
              cursor: "pointer",
              fontSize: "21px",
              lineHeight: 1,
            }}
          >
            ×
          </button>
        </div>

        {!caricamento && !errore && dati && (
          <div
            style={{
              display: "flex",
              overflowX: "auto",
              background: "#fff",
              borderBottom: "1px solid #dfe5eb",
              padding: "0 10px",
            }}
          >
            <TabButton
              active={tab === "panoramica"}
              onClick={() => setTab("panoramica")}
            >
              Panoramica
            </TabButton>
            <TabButton
              active={tab === "anagrafica"}
              onClick={() => setTab("anagrafica")}
            >
              Anagrafica
            </TabButton>
            <TabButton
              active={tab === "tecnico"}
              onClick={() => setTab("tecnico")}
            >
              Dati tecnici
            </TabButton>
            <TabButton
              active={tab === "documenti"}
              onClick={() => setTab("documenti")}
            >
              Documenti
            </TabButton>
            <TabButton
              active={tab === "collaudi"}
              onClick={() => setTab("collaudi")}
            >
              Collaudi
            </TabButton>
            <TabButton
              active={tab === "interventi"}
              onClick={() => setTab("interventi")}
            >
              Interventi
            </TabButton>
          </div>
        )}

        <div style={{ padding: "18px" }}>
          {caricamento && (
            <div
              style={{
                padding: "48px 20px",
                textAlign: "center",
                fontWeight: 700,
              }}
            >
              Caricamento scheda cliente…
            </div>
          )}

          {!caricamento && errore && (
            <div
              style={{
                padding: "18px",
                borderRadius: "10px",
                border: "1px solid #d58484",
                background: "#fff0f0",
                color: "#8a1e1e",
                fontWeight: 700,
              }}
            >
              {errore}
            </div>
          )}

          {!caricamento && !errore && dati && (
            <>
              {tab === "panoramica" && (
                <div style={{ display: "grid", gap: "14px" }}>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(150px, 1fr))",
                      gap: "10px",
                    }}
                  >
                    <StatCard
                      label="Interventi"
                      value={statistiche.totali}
                      description="Storico complessivo"
                    />
                    <StatCard
                      label="Aperti"
                      value={statistiche.aperti}
                      description="Da gestire"
                    />
                    <StatCard
                      label="Completati"
                      value={statistiche.completati}
                    />
                    <StatCard
                      label="Documenti"
                      value={documenti.length}
                      description="Archivio cliente"
                    />
                  </div>

                  <Section title="Riepilogo">
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fit, minmax(190px, 1fr))",
                        gap: "10px",
                      }}
                    >
                      <Dato label="Indirizzo">
                        {valore(cliente.indirizzo)}
                      </Dato>
                      <Dato label="Telefono">
                        {valore(cliente.telefono)}
                      </Dato>
                      <Dato label="Email">{valore(cliente.email)}</Dato>
                      <Dato label="Tipo impianto">
                        {valore(cliente.tipo_impianto)}
                      </Dato>
                      <Dato label="Ultimo intervento">
                        {ultimoIntervento
                          ? formattaData(ultimoIntervento.data)
                          : "—"}
                      </Dato>
                      <Dato label="Prossima manutenzione">
                        {formattaData(
                          cliente.scadenza_prossima_manutenzione
                        )}
                      </Dato>
                    </div>
                  </Section>
                </div>
              )}

              {tab === "anagrafica" && (
                <Section title="Anagrafica e contatti">
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(210px, 1fr))",
                      gap: "10px",
                    }}
                  >
                    <Dato label="Indirizzo">
                      {valore(cliente.indirizzo)}
                    </Dato>
                    <Dato label="Telefono">
                      {valore(cliente.telefono)}
                    </Dato>
                    <Dato label="Secondo telefono">
                      {valore(cliente.telefono_secondario)}
                    </Dato>
                    <Dato label="Email">{valore(cliente.email)}</Dato>
                    <Dato label="Codice fiscale / P.IVA">
                      {valore(cliente.codice_fiscale)}
                    </Dato>
                    <Dato label="Referente">
                      {valore(cliente.referente)}
                    </Dato>
                  </div>

                  {cliente.note_generali && (
                    <div style={{ marginTop: "10px" }}>
                      <Dato label="Note cliente" wide>
                        {cliente.note_generali}
                      </Dato>
                    </div>
                  )}
                </Section>
              )}

              {tab === "tecnico" && (
                <Section title="Dati tecnici attuali">
                  <div
                    style={{
                      padding: "10px 12px",
                      marginBottom: "13px",
                      borderRadius: "9px",
                      background: "#fff8e8",
                      border: "1px solid #efd79d",
                      color: "#725500",
                      fontSize: "13px",
                    }}
                  >
                    Dati legacy associati al cliente. Nella fase impianti
                    verranno separati per sito/impianto senza perdere nulla.
                  </div>

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(205px, 1fr))",
                      gap: "10px",
                    }}
                  >
                    <Dato label="Tipo impianto">
                      {valore(cliente.tipo_impianto)}
                    </Dato>
                    <Dato label="Marca e modello">
                      {valore(cliente.marca_modello)}
                    </Dato>
                    <Dato label="Matricola">
                      {valore(cliente.numero_matricola)}
                    </Dato>
                    <Dato label="Contratto">
                      {valore(cliente.numero_contratto)}
                    </Dato>
                    <Dato label="Garanzia">
                      {valore(cliente.stato_garanzia)}
                    </Dato>
                    <Dato label="Manutenzione">
                      {valore(cliente.tipo_manutenzione)}
                    </Dato>
                    <Dato label="Installazione">
                      {formattaData(cliente.data_installazione)}
                    </Dato>
                    <Dato label="Prossima manutenzione">
                      {formattaData(
                        cliente.scadenza_prossima_manutenzione
                      )}
                    </Dato>
                    <Dato label="Numero zone">
                      {valore(cliente.numero_zone)}
                    </Dato>
                  </div>

                  {cliente.descrizione_configurazione && (
                    <div style={{ marginTop: "10px" }}>
                      <Dato label="Configurazione impianto" wide>
                        {cliente.descrizione_configurazione}
                      </Dato>
                    </div>
                  )}

                  {cliente.note_interventi_futuri && (
                    <div style={{ marginTop: "10px" }}>
                      <Dato label="Indicazioni operative" wide>
                        {cliente.note_interventi_futuri}
                      </Dato>
                    </div>
                  )}

                  {cliente.problemi_ricorrenti && (
                    <div style={{ marginTop: "10px" }}>
                      <Dato label="Problemi ricorrenti" wide>
                        {cliente.problemi_ricorrenti}
                      </Dato>
                    </div>
                  )}
                </Section>
              )}

              {tab === "documenti" && (
                <Section title="Documenti cliente">
                  <div
                    style={{
                      padding: "12px",
                      marginBottom: "14px",
                      borderRadius: "10px",
                      background: "#eef5fb",
                      border: "1px solid #cbddeb",
                      color: "#36566f",
                      fontSize: "13px",
                    }}
                  >
                    Archivio documentale cliente compatibile con il sistema
                    esistente. I nuovi file vengono aggiunti senza cancellare
                    quelli già presenti e diventano disponibili anche nel
                    Portale Cliente.
                  </div>

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(180px, 1fr))",
                      gap: "9px",
                      marginBottom: "14px",
                    }}
                  >
                    {[
                      ["Foto impianto", "foto_impianto"],
                      ["Documenti firmati", "documenti_firmati"],
                      ["Verbale collaudo", "verbale_collaudo"],
                      ["Manualistica", "manualistica"],
                      ["Certificazioni", "certificazioni"],
                    ].map(([label, field]) => {
                      const count = documenti.filter(
                        (item) => item.categoria === label
                      ).length;

                      return (
                        <button
                          key={field}
                          type="button"
                          onClick={() => {
                            setDocumentCategory(field);
                            setDocumentUploadMessage("");
                          }}
                          style={{
                            textAlign: "left",
                            padding: "11px 12px",
                            borderRadius: "10px",
                            border:
                              documentCategory === field
                                ? "2px solid #244f79"
                                : "1px solid #dfe5eb",
                            background:
                              documentCategory === field ? "#f3f8fc" : "#fff",
                            cursor: "pointer",
                            color: "#243750",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: "10px",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: 850,
                                minWidth: 0,
                              }}
                            >
                              {label}
                            </span>
                            <span
                              style={{
                                flex: "0 0 auto",
                                minWidth: "28px",
                                padding: "3px 7px",
                                borderRadius: "999px",
                                background:
                                  documentCategory === field
                                    ? "#244f79"
                                    : "#eef2f6",
                                color:
                                  documentCategory === field
                                    ? "#fff"
                                    : "#586779",
                                fontSize: "10px",
                                fontWeight: 850,
                                textAlign: "center",
                              }}
                            >
                              {count}
                            </span>
                          </div>
                          <div
                            style={{
                              marginTop: "4px",
                              fontSize: "10px",
                              color: "#8a95a1",
                            }}
                          >
                            {count === 1 ? "1 file disponibile" : `${count} file disponibili`}
                          </div>
                        </button>
                      );
                    })}
                  </div>

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "minmax(0, 1fr) auto",
                      gap: "10px",
                      alignItems: "end",
                      padding: "13px",
                      marginBottom: "15px",
                      borderRadius: "11px",
                      border: "1px solid #dfe5eb",
                      background: "#fafbfc",
                    }}
                  >
                    <div style={{ minWidth: 0 }}>
                      <label
                        style={{
                          display: "block",
                          marginBottom: "6px",
                          fontSize: "11px",
                          fontWeight: 850,
                          color: "#536274",
                          textTransform: "uppercase",
                          letterSpacing: "0.04em",
                        }}
                      >
                        Aggiungi file ·{" "}
                        {{
                          foto_impianto: "Foto impianto",
                          documenti_firmati: "Documenti firmati",
                          verbale_collaudo: "Verbale collaudo",
                          manualistica: "Manualistica",
                          certificazioni: "Certificazioni",
                        }[documentCategory]}
                      </label>
                      <input
                        type="file"
                        multiple
                        disabled={documentUploadBusy}
                        onChange={(event) =>
                          setDocumentFiles(Array.from(event.target.files || []))
                        }
                        style={{
                          width: "100%",
                          fontSize: "13px",
                          color: "#33465a",
                        }}
                      />
                      {documentFiles.length > 0 && (
                        <div
                          style={{
                            marginTop: "6px",
                            fontSize: "11px",
                            color: "#69737d",
                          }}
                        >
                          {documentFiles.length}{" "}
                          {documentFiles.length === 1
                            ? "file selezionato"
                            : "file selezionati"}
                        </div>
                      )}
                    </div>

                    <button
                      type="button"
                      onClick={uploadDocumenti}
                      disabled={documentUploadBusy || documentFiles.length === 0}
                      style={{
                        padding: "9px 13px",
                        borderRadius: "8px",
                        border: "1px solid #244f79",
                        background:
                          documentUploadBusy || documentFiles.length === 0
                            ? "#aab7c4"
                            : "#244f79",
                        color: "#fff",
                        fontWeight: 850,
                        cursor:
                          documentUploadBusy || documentFiles.length === 0
                            ? "not-allowed"
                            : "pointer",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {documentUploadBusy ? "Caricamento…" : "Carica"}
                    </button>
                  </div>

                  {documentUploadMessage && (
                    <div
                      style={{
                        padding: "9px 11px",
                        marginBottom: "12px",
                        borderRadius: "8px",
                        background: documentUploadMessage.includes("correttamente")
                          ? "#edf8f0"
                          : "#fff0f0",
                        border: documentUploadMessage.includes("correttamente")
                          ? "1px solid #b8dfc2"
                          : "1px solid #e2b1b1",
                        color: documentUploadMessage.includes("correttamente")
                          ? "#2e6d3d"
                          : "#8a1e1e",
                        fontSize: "12px",
                        fontWeight: 700,
                      }}
                    >
                      {documentUploadMessage}
                    </div>
                  )}

                  {documenti.length === 0 ? (
                    <div
                      style={{
                        padding: "30px 18px",
                        borderRadius: "11px",
                        border: "1px dashed #cbd4dd",
                        background: "#fafbfc",
                        textAlign: "center",
                        color: "#6f7c89",
                      }}
                    >
                      <div style={{ fontWeight: 800, color: "#415466" }}>
                        Nessun documento presente
                      </div>
                      <div style={{ marginTop: "5px", fontSize: "12px" }}>
                        Seleziona una categoria, scegli uno o più file e premi
                        Carica.
                      </div>
                    </div>
                  ) : (
                    <div style={{ display: "grid", gap: "9px" }}>
                      {documenti.map((documento) => {
                        const fieldByLabel = {
                          "Foto impianto": "foto_impianto",
                          "Documenti firmati": "documenti_firmati",
                          "Verbale collaudo": "verbale_collaudo",
                          Manualistica: "manualistica",
                          Certificazioni: "certificazioni",
                        };
                        const deleteKey = `${fieldByLabel[documento.categoria] || ""}:${documento.path}`;
                        const deleting = documentDeleteBusy === deleteKey;

                        return (
                          <div
                            key={documento.id}
                            style={{
                              display: "grid",
                              gridTemplateColumns: "minmax(0, 1fr) auto",
                              gap: "8px",
                              alignItems: "stretch",
                            }}
                          >
                            <DocumentoCard
                              categoria={documento.categoria}
                              path={documento.path}
                            />
                            <button
                              type="button"
                              onClick={() => deleteDocumento(documento)}
                              disabled={Boolean(documentDeleteBusy)}
                              title="Rimuovi documento"
                              style={{
                                alignSelf: "center",
                                padding: "8px 10px",
                                borderRadius: "8px",
                                border: "1px solid #d6a6a6",
                                background: deleting ? "#ead7d7" : "#fff5f5",
                                color: "#9b2c2c",
                                fontSize: "11px",
                                fontWeight: 850,
                                cursor: documentDeleteBusy ? "not-allowed" : "pointer",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {deleting ? "Rimozione…" : "Elimina"}
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </Section>
              )}

              {tab === "collaudi" && (
                <ClienteCollaudi clienteId={clienteId} cliente={cliente} />
              )}

              {tab === "interventi" && (
                <Section title="Timeline interventi">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "-34px",
                      marginBottom: "14px",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "12px",
                        color: "#69737d",
                        fontWeight: 700,
                      }}
                    >
                      {interventi.length} elementi
                    </span>
                  </div>

                  {interventi.length === 0 ? (
                    <div
                      style={{
                        padding: "20px",
                        borderRadius: "10px",
                        background: "#f6f8fa",
                        textAlign: "center",
                        color: "#69737d",
                      }}
                    >
                      Nessun intervento associato.
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "grid",
                        gap: "9px",
                        maxHeight: "560px",
                        overflowY: "auto",
                        paddingRight: "4px",
                      }}
                    >
                      {interventi.map((intervento) => (
                        <article
                          key={intervento.id}
                          style={{
                            padding: "13px",
                            borderRadius: "11px",
                            border: "1px solid #e0e5ea",
                            background: "#fbfcfd",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              gap: "12px",
                              alignItems: "flex-start",
                              flexWrap: "wrap",
                            }}
                          >
                            <div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  flexWrap: "wrap",
                                }}
                              >
                                <strong>
                                  {intervento.numero_foglio_intervento ||
                                    `Intervento #${intervento.id}`}
                                </strong>
                                <StatoBadge stato={intervento.stato} />
                              </div>

                              <div
                                style={{
                                  marginTop: "5px",
                                  fontSize: "12px",
                                  color: "#69737d",
                                }}
                              >
                                {formattaData(intervento.data)}
                                {intervento.tecnico
                                  ? ` · ${intervento.tecnico}`
                                  : ""}
                              </div>
                            </div>
                          </div>

                          {(intervento.causale ||
                            intervento.descrizione) && (
                            <div
                              style={{
                                marginTop: "9px",
                                lineHeight: 1.4,
                                fontSize: "14px",
                              }}
                            >
                              {intervento.causale ||
                                intervento.descrizione}
                            </div>
                          )}

                          {intervento.lavoriEseguiti && (
                            <div
                              style={{
                                marginTop: "8px",
                                padding: "8px 9px",
                                borderRadius: "8px",
                                background: "#f1f4f7",
                                fontSize: "13px",
                                lineHeight: 1.4,
                              }}
                            >
                              <strong>Lavori:</strong>{" "}
                              {intervento.lavoriEseguiti}
                            </div>
                          )}

                          {intervento.indirizzo && (
                            <div
                              style={{
                                marginTop: "8px",
                                fontSize: "12px",
                                color: "#69737d",
                              }}
                            >
                              {intervento.indirizzo}
                            </div>
                          )}
                        </article>
                      ))}
                    </div>
                  )}
                </Section>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClienteSchedaOperativa;
